<template>
  <v-container class="fill-height" >
    <v-row
      align="center"
      justify="center"
    >
      <v-col :cols="width">
        <v-progress-linear
          :active="true"
          :buffer-value="100"
          :height="4"
          :indeterminate="true"
          :rounded="true"
          :value="0"
          color="primary"
        ></v-progress-linear>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/* eslint-disable indent */

  export default {
    name: 'ProgressLinear',
    props: {
      width: {
        type: Number,
        default: 12
      }
    }
  }
</script>

<style scoped>

</style>
